var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 535 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.16 39.627c-13.506-36.39-50.973-10.967-56.637 9.97C23.968 34.642-.43 49.597.006 82.001H535c-3.05-16.45-30.932-40.877-47.492-16.45-40.076-36.89-135.922-75.64-135.922-15.954 0 0-57.072-39.88-104.994-46.36-47.923-6.481-131.571-7.146-149.433 36.39Z",
    fill: "#fff"
  })));
};

export default SvgCloud;